/**
 * Per-player pill badges showing stone count with player colors.
 * Compact row for title bar; shows ready/eliminated state.
 */

interface PlayerChip {
  readonly playerId: string;
  readonly label: string;
  readonly count: number;
  readonly color: string;
  readonly bgColor: string;
  readonly isReady: boolean;
  readonly isEliminated: boolean;
}

interface ScoreChipsProps {
  readonly players: ReadonlyArray<PlayerChip>;
}

export function ScoreChips({ players }: ScoreChipsProps) {
  return (
    <output
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
      }}
      aria-label="플레이어 현황"
    >
      {players.map((p) => (
        <span
          key={p.playerId}
          title={`${p.label}: ${p.count}개${p.isReady ? " 준비완료" : ""}${p.isEliminated ? " 탈락" : ""}`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            padding: "3px 8px",
            borderRadius: "12px",
            backgroundColor: p.isEliminated
              ? "var(--cn-asf-surface-secondary)"
              : p.bgColor,
            opacity: p.isEliminated ? 0.5 : 1,
            transition: "opacity 0.2s",
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: 1,
          }}
        >
          {/* Color dot */}
          <span
            style={{
              display: "inline-block",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: p.color,
              flexShrink: 0,
            }}
          />
          {/* Count */}
          <span style={{ color: p.color }}>{p.count}</span>
          {/* Ready indicator */}
          {p.isReady && (
            <span
              style={{ color: "var(--cn-asf-ready)", fontSize: "10px" }}
              aria-hidden="true"
            >
              ✓
            </span>
          )}
        </span>
      ))}
    </output>
  );
}
